import { render, staticRenderFns } from "./MovementCard.vue?vue&type=template&id=1c27f99b&scoped=true"
import script from "./MovementCard.vue?vue&type=script&lang=js"
export * from "./MovementCard.vue?vue&type=script&lang=js"
import style0 from "./MovementCard.vue?vue&type=style&index=0&id=1c27f99b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c27f99b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VContainer,
  VDataTable,
  VFlex,
  VForm,
  VLayout,
  VTextField,
})
